import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const LOGIN_MAX_WIDTH = '376px';

export const useStyles = makeStyles(({ breakpoints, spacing, palette }: Theme) => ({
  form: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [breakpoints.up('md')]: {
      marginTop: '-100px', // To discount logo container
    },
  },

  title: {
    color: palette.primary.main,
    fontWeight: 'bold',
    marginBottom: spacing(2),
  },

  loginCard: {
    width: '26%',
    [breakpoints.down('md')]: {
      width: '90%',
    },
    gap: spacing(2),
    maxWidth: LOGIN_MAX_WIDTH,
    background: `${palette.neutral[500]} !important`,
  },

  forgotPassword: {
    marginTop: spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    '& a': {
      color: palette.neutral[100],
      textDecoration: 'underline',
    },
  },

  passwordIcon: {
    cursor: 'pointer',
  },
}));

export default useStyles;
